// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EbdKM","placeholdersHeader":"styles_placeholdersHeader__lwmdH","editorStyle":"styles_editorStyle__3aHsz","placeholdersBox":"styles_placeholdersBox__2p7Cb"};